class Navbar {
    static showMain() {
        document.querySelector('.navbar-search').classList.add('d-none')
        document.querySelector('.navbar-main').classList.remove('d-none')
    }

    static showSearch() {
        document.querySelector('.navbar-main').classList.add('d-none')
        document.querySelector('.navbar-search').classList.remove('d-none')
    }
}

document.addEventListener('DOMContentLoaded', e => {
    document.querySelector('.navbar-btn-show-search')
        .addEventListener('click', e => Navbar.showSearch())

    document.querySelector('.navbar-btn-show-main')
        .addEventListener('click', e => Navbar.showMain())
}, false);

export default Navbar
